import { render } from "./UIWorks.vue?vue&type=template&id=e18e3fe8&scoped=true"
import script from "./UIWorks.vue?vue&type=script&lang=js"
export * from "./UIWorks.vue?vue&type=script&lang=js"

import "./UIWorks.vue?vue&type=style&index=0&id=e18e3fe8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e18e3fe8"

export default script